<template>
  <div class="listStyle" v-if="info.searches && info.searches.length > 0">
    <div class="title">
      <img :src="info.titleImg" alt="" />
      <span>{{ info.title }}</span>
      <div class="all" @click="toList(info.categoryId, info.parentId)">
        <div style="float: left; margin-left: 15px">
          {{ TLang("全部", "home") }}
        </div>
        <div style="float: left">
          <i class="iconfont health__arrow_right"></i>
        </div>
      </div>
    </div>
    <div class="content" v-if="info.searches">
      <div
        class="big"
        @click="toDetail(info.searches[0].id)"
        style="cursor: pointer"
      >
        <div class="goodsImg-wrap">
          <img
            :src="info.searches.length && info.searches[0].imgUrl"
            alt=""
            class="goodsImg"
          />

          <div class="show-detail-info">
            <div class="show-detail-info-wrap">
              <div class="show-detail-info-item">
                <h4>{{ TLang("时间", "my") }}</h4>
                <p>{{ info.searches[0] && info.searches[0].timeInfo }}</p>
              </div>

              <div class="show-detail-info-item">
                <h4>{{ TLang("场馆", "my") }}</h4>
                <p>
                  {{ info.searches[0] && info.searches[0].venueName }}
                  <span></span>
                  {{ info.searches[0] && info.searches[0].cityName }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div
          class="priview"
          v-if="info.searches.length && info.searches[0].projectType == 1"
        >
          <img
            src="@/assets/imgs/index/preview_detail.png"
            alt=""
            style="width: 100%; height: 100%"
          />
        </div>
        <div class="bigInfo">
          <div class="bigTitle">
            {{ info.searches.length && info.searches[0].name }}
          </div>
          <Price
            class="bigPrice"
            type="big"
            :price="info.searches.length && info.searches[0].sellingPrice"
            :onlyOnePrice="
              info.searches.length && info.searches[0].onlyOnePrice
            "
          />
        </div>
      </div>
      <div class="small-price">
        <ul>
          <li
            v-for="(item, index) in list"
            :key="index"
            @click="toDetail(item.id)"
            style="cursor: pointer"
            v-if="index < 6"
          >
            <div class="leftImg">
              <img :src="item.imgUrl" alt="" />
              <div class="priview" v-if="item.projectType == 1">
                <img
                  src="@/assets/imgs/index/preview_detail.png"
                  alt=""
                  style="width: 100%; height: 100%"
                />
              </div>
            </div>
            <div class="rightInfo">
              <div class="showTitle" :title="item.name">{{ item.name }}</div>
              <div class="showTime">
                <span>{{ item.timeInfo }}</span>
              </div>
              <div class="location">
                <span class="venue-name">
                  <span >{{ item.venueName }}</span>
                  <span style="margin-left: 10px" class="split">{{
                    item.cityName
                  }}</span>
                </span>
              </div>
              <Price
                class="rightPrice"
                :price="item.sellingPrice"
                :onlyOnePrice="item.onlyOnePrice"
              />
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Price from "./price";
import { unionFlag } from "@/utils";
export default {
  name: "listStyle2",
  data() {
    return {};
  },
  props: {
    info: Object,
  },
  components: {
    Price,
  },
  computed: {
    list: function () {
      let arr = JSON.parse(JSON.stringify(this.info)).searches;
      arr.splice(0, 1);
      return arr;
    },
  },
  methods: {
    toDetail(id) {
      let union = unionFlag();
      console.log(union);
      let { city } = this.$route.query;
      window.open(
        `/drama_pc/detail?id=${id}&city=${city}` +
          (union ? `&union=${union}` : ""),
        this.isFeishuOrDingding ? "_self" : "_blank"
      );
    },
    toList(categoryId, parentId) {
      this.$router.push({
        path: "/list",
        query: {
          categoryId,
          parentId,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.title {
  img {
    width: 36px;
    height: 36px;
    margin-top: 4.5px;
    margin-right: 12px;
  }
  font-size: 32px;
  height: 45px;
  line-height: 45px;
  font-weight: 540;
  margin-bottom: 28px;
  position: relative;
  .all {
    width: 65px;
    height: 24px;
    border-radius: 2px;
    border: 1px solid #e0e6ed;
    line-height: 22px;
    text-align: center;
    font-size: 14px;
    color: #aab1b8;
    position: absolute;
    right: 0;
    top: 10px;
    overflow: hidden;
    cursor: pointer;
  }
  .all:hover {
    color: #f44545;
  }
  .iconfont {
    padding-top: 2px;
  }
}
.content {
  height: 358px;
  margin-top: 28px;
  .clearfix;
  .big {
    float: left;
    width: 266px;
    height: 358px;
    position: relative;
    &:hover {
      .goodsImg-wrap .show-detail-info {
        display: block;
      }
    }
    .goodsImg-wrap {
      position: relative;
      .show-detail-info {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.6);
        color: #fff;
        z-index: 9;
        display: none;
      }
      .show-detail-info-wrap {
        position: absolute;
        top: 50%;
        left: 0;
        width: 100%;
        margin-top: -52px;
      }
      .show-detail-info-item {
        margin-bottom: 24px;
        padding: 0 12px;
        line-height: 20px;
        &:last-child {
          margin-bottom: 0;
        }
        h4 {
          color: #cbcdce;
          font-size: 12px;
        }
        p {
          font-size: 14px;
          color: #fff;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          span {
            width: 1px;
            height: 10px;
            background: #fff;
            display: inline-block;
            margin: 0 2px;
          }
        }
      }
    }
    .goodsImg {
      width: 100%;
      height: 100%;
    }
    .priview {
      width: 48px;
      height: 25px;
      position: absolute;
      top: 0;
      right: 0;
      display: inline-block;
    }
    .bigInfo {
      position: absolute;
      width: 100%;
      height: 120px;
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.46) 43%,
        rgba(0, 0, 0, 1) 100%
      );
      bottom: 0;
      left: 0;
      .bigTitle {
        height: 20px;
        color: white;
        font-size: 14px;
        padding: 0 12px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        margin-top: 50px;
      }
      .bigPrice {
        padding: 8px 12px;
      }
    }
  }
  .small-price {
    box-sizing: border-box;
    float: left;
    margin-left: 32px;
    height: 100%;
    width: 902px;
    overflow: hidden;
    ul {
      .clearfix;
    }
    ul li {
      width: 284px;
      float: left;
      margin-right: 24px;
      height: 166px;
      .clearfix;
      .leftImg {
        width: 124px;
        height: 100%;
        float: left;
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
        .priview {
          width: 48px;
          height: 25px;
          position: absolute;
          top: 0;
          right: 0;
          display: inline-block;
        }
      }
      .rightInfo {
        position: relative;
        width: 148px;
        height: 100%;
        float: left;
        margin-left: 12px;
        .showTitle {
          height: 44px;
          line-height: 22px;
          font-weight: 500;
          font-size: 16px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
        .showTime {
          height: 17px;
          line-height: 17px;
          font-size: 12px;
          margin-top: 23px;
          color: #222222;
        }
        .location {
          height: 16px;
          line-height: 16px;
          font-size: 12px;
          margin-top: 8px;
          color: #555555;
          .venue-name {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .split {
            position: relative;
          }
          .split:before {
            content: "";
            height: 12px;
            position: absolute;
            left: -5px;
            background-color: #cbcdce;
            width: 1px;
            top: 10%;
          }
        }
        .rightPrice {
          position: absolute;
          bottom: 0;
          left: 0;
        }
      }
    }
    ul li:nth-child(3n) {
      margin-right: 0;
    }
    ul li:nth-child(n + 4) {
      margin-top: 25px;
    }
  }
}
</style>
